<script setup lang="ts">
/* Toasts — renders the reactive toast queue from useToasts. */
import { useToasts, type Toast } from '@/composables/useToasts'
const { toasts, dismissToast } = useToasts()

function runAction(t: Toast): void {
  t.action?.onAction()
  dismissToast(t.id)
}
</script>

<template>
  <div class="toasts" aria-live="polite">
    <div v-for="t in toasts" :key="t.id" class="toast" :class="{ 'is-error': t.kind === 'error' }">
      <span class="toast-msg">{{ t.msg }}</span>
      <button v-if="t.action" type="button" class="toast-action" @click="runAction(t)">
        {{ t.action.label }}
      </button>
    </div>
  </div>
</template>
